import { register, format } from "./format";
import currency from "./currency";
import padding from "./padding";
import { fullDate, longDate, shortDate } from "./date-formats";
import * as Sub from "./str";
import { currencyNp } from "./negative-parences";
import list from "./list";

register(currency);
register(currency, "CCY");

register(currencyNp);
register(currencyNp, "(CCY)");

register(padding);
register(padding, "PAD");

register(shortDate);
register(shortDate, "DATE");

register(longDate);
register(longDate, "LONGDATE");

register(fullDate);
register(fullDate, "FULLDATE");

register(Sub.slice);
register(Sub.slice, "SLICE");
register(Sub.slice, "SUBSTR");

register(Sub.left);
register(Sub.left, "LEFT");

register(Sub.right);
register(Sub.right, "RIGHT");

register(list);
register(list, "LIST");

export default format;
